<template>
  <div :class="{ 'wrapper--with-button': !readOnly }" class="wrapper">
    <a-collapse default-active-key="1" :bordered="false">
      <a-collapse-panel
        v-for="(course, i) in courses"
        :key="i"
        :header="course.name"
      >
        <inner-list
          :loading="loading"
          :results="resultsPerCourse[course.id]"
          :readOnly="readOnly"
          :key="i"
          @editInstance="openModal"
          @listUpdated="fetchData"
        />
        <a-button
          slot="extra"
          type="primary"
          icon="plus"
          v-if="!readOnly"
          class="button"
          @click="openModal(course.id)"
        >
          Dodaj harmonogram
        </a-button>
      </a-collapse-panel>
    </a-collapse>

    <course-payment-modal ref="coursePaymentModal" @formSubmitted="fetchData" />
  </div>
</template>
<script>
import InnerList from './InnerList'
import { Course, CoursePayment } from '@/api'
import PaginatedList from '@/components/layout/PaginatedList'
import CoursePaymentModal from './CoursePaymentModal'
import { groupBy } from 'lodash'

export default {
  extends: PaginatedList,
  components: {
    InnerList,
    CoursePaymentModal
  },
  props: {
    studentId: {
      type: [Number, String],
      required: true
    },
    readOnly: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    openModal(courseId) {
      this.$refs.coursePaymentModal.openModal(courseId)
    },
    fetchCourses() {
      const params = { students: this.studentId }
      Course.fetch({}, { params }).then(res => {
        this.courses = res.data.results
      })
    }
  },
  mounted() {
    this.fetchCourses()
  },
  data() {
    return {
      service: CoursePayment,
      courses: []
    }
  },
  computed: {
    params() {
      const user = this.studentId
      return {
        student: user,
        page_size: 'max'
      }
    },
    resultsPerCourse() {
      return groupBy(this.results, 'course')
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  &--with-button {
    ::v-deep .ant-collapse-header {
      height: 88px;
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
  }
}

.button {
  display: block;
  margin-top: -1px;
}
</style>
